import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // React.StrictMode causes duplicate API calls in development
  // Uncomment for testing side effects and component purity
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
